export default __webpack_public_path__ + "static/media/pilkki.39c3592d.jpg";